module.exports = __webpack_public_path__ + "img/1.a988c0f8.png";